var Storage = {
    getCookie: function (key) {
        var cookies = document.cookie;
        if (cookies.indexOf(key) >= 0) {
            var parts = cookies.split(key + "=");
            var parts2 = parts[1].split(';');
            return parts2[0];
        }
        return null;
    },
    setCookie: function (key, value) {
        var date = new Date();
        date.setFullYear(date.getFullYear() + 5);
        document.cookie = key + "=" + value + "; expires=" + date.toUTCString() + "; path=/; SameSite=None; Secure;";
    },
    removeCookie: function (key) {
        var date = new Date();
        date.setFullYear(date.getFullYear() - 1);
        document.cookie = key + "=; expires=" + date.toUTCString() + "; path=/; SameSite=None; Secure;";
    },
    get: function (key, asCookie) {
        if (asCookie === void 0) { asCookie = false; }
        if (asCookie) {
            return Storage.getCookie(key);
        }
        else {
            if (typeof localStorage[key] !== 'undefined') {
                return JSON.parse(localStorage[key]);
            }
        }
        return null;
    },
    set: function (key, value, asCookie) {
        if (asCookie === void 0) { asCookie = false; }
        if (asCookie) {
            Storage.setCookie(key, value);
        }
        else {
            localStorage[key] = JSON.stringify(value);
        }
        return value;
    },
    remove: function (key, asCookie) {
        if (asCookie === void 0) { asCookie = false; }
        if (asCookie) {
            Storage.removeCookie(key);
        }
        else {
            delete localStorage[key];
        }
    }
};
export default Storage;
